import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[inViewport]',
  standalone: false
})
export class InViewportDirective implements OnInit, OnDestroy {

  @Input() public inViewportOptions = {
    root: null,
    rootMargin: '0px',
    threshold: [0.1]
  };

  @Output() public inViewportAction = new EventEmitter<any>();

  private intersectionObserver: IntersectionObserver;

  constructor(private el: ElementRef) { }

  public ngOnInit(): void {
    this.intersectionObserver = new IntersectionObserver((entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
      entries.forEach(entry => {
        this.inViewportAction.emit({ target: entry.target, isVisible: entry.isIntersecting });
      });
    }, this.inViewportOptions);

    this.intersectionObserver.observe(this.el.nativeElement);
  }

  public ngOnDestroy(): void {
    if (this.intersectionObserver) {
      this.intersectionObserver.unobserve(this.el.nativeElement);
    }
  }
}
